import { render, staticRenderFns } from "./speech-bubble-with-letter-i.svg?vue&type=template&id=9a2b6314&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports